import axios from 'axios';

const endpointAPI = 'https://uk9p3kad21.execute-api.us-east-1.amazonaws.com/dev';
const endpointAPIVariables = 'https://h83p6dmwgk.execute-api.us-east-1.amazonaws.com/dev/data';
const endpointAPIClima = 'https://pgiqr57ll5.execute-api.us-east-1.amazonaws.com/dev/data';

export default {
  getCountries() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/ubication/countries`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getUbicationByHash(hash) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/ubication/${hash}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getUbicationById(idUbication) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/ubication/id/${idUbication}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  addIndice(newIndice) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await axios.post(`${endpointAPIVariables}/indices`, {
          data: {
            newIndice,
          },
        });
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  updateIndice(updateIndice) {
    return new Promise((resolve, reject) => {
      axios.put(`${endpointAPIVariables}/indices`, {
        data: {
          updateIndice,
        },
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  deleteIndice(IdIndice) {
    return new Promise((resolve, reject) => {
      axios.delete(`${endpointAPIVariables}/indices/${IdIndice}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  addDataIndice(idIndice, dataIndice, dataUpload) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/indices/${idIndice}/data`, {
        data: {
          dataIndice,
          dataUpload
        },
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getDataIndice(IdIndice) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/indices/${IdIndice}/data`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getIndices() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/indices`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getIndice(idIndice) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/indices/${idIndice}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  addNewVariable(newVariable) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/variables`, {
        data: newVariable,
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  updateVariable(updateVariable) {
    return new Promise((resolve, reject) => {
      axios.put(`${endpointAPIVariables}/variables`, {
        data: {
          updateVariable,
        },
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  deleteVariable(idVariable) {
    return new Promise((resolve, reject) => {
      axios.delete(`${endpointAPIVariables}/variables/${idVariable}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  addDataVariable(idVariable, dataVariable, dataUpload) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/variables/${idVariable}/data`, {
        data: {
          dataVariable,
          dataUpload
        },
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getVariables() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/variables`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getDataVariable(idVariable) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/variables/${idVariable}/data`).then((res) => {
        resolve(res.data);
      });
    });
  },
  deleteDataVariable(idVariable) {
    return new Promise((resolve, reject) => {
      axios.delete(`${endpointAPIVariables}/variables/${idVariable}/data`).then((res) => {
        resolve(res.data);
      });
    });
  },
  importarAlcaldes(MetaUbication) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPI}/ubication/update-meta-ubication`, {
        data: {
          MetaUbication,
        },
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getVariable(idVariable) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/variables/${idVariable}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  getDataByIdUbication(idUbication) {
    return new Promise((resolve, reject) => {

      Promise.all([axios.get(`${endpointAPIVariables}/ubication/${idUbication}`), axios.get(`${endpointAPIClima}/escenarios-climaticos/${idUbication}?rcp=85`)])
        .then(values => {

          let Data = values[0].data.data
          let Clima = values[1].data.data

          resolve({
            Data,
            Clima
          });

        }, reason => {
          console.log(reason);
        })

    });
  },
  getUbicationsByComparisonVariable(idVariable, valorVariable) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPIVariables}/variables/${idVariable}/comparison?value=${valorVariable}`).then((res) => {
        resolve(res.data);
      });
    });
  },
  //PUBLICATIONS
  addPublication(newPublication) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/publications`, {
        data: newPublication,
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getPublicaciones() {
    return axios.get(`${endpointAPIVariables}/publications`);
  },
  deletePublication(idPublication) {
    return axios.delete(`${endpointAPIVariables}/publications/${idPublication}`);
  },
  getPublication(idPublication) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios.get(`${endpointAPIVariables}/publications/${idPublication}`);
        resolve(data.data);
      } catch (err) {
        reject(err);
      }
    })

  },
  getDataPublicationByIdUbication(idPublication, idUbication) {
    return new Promise(async (resolve, reject) => {
      try {

        let data = await axios.get(`${endpointAPIVariables}/publications/${idPublication}/data/ubication/${idUbication}`);
        resolve(data.data);

      } catch (err) {
        reject(err);
      }
    })
  },
  getMunicipiosJSON() {
    return axios.get(`https://s3.amazonaws.com/resources.ciat.cultivandofuturo.com/municipios-hn.json`);
  },
  addPatrocinador(newSponsor) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/sponsors`, {
        ...newSponsor,
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getPatrocinadores() {
    return axios.get(`${endpointAPIVariables}/sponsors`);
  },
  getPatrocinadorById(sponsorId) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios.get(`${endpointAPIVariables}/sponsors/${sponsorId}`);
        resolve(data.data);
      } catch (err) {
        reject(err);
      }
    })
  },
  deleteSponsor(sponsorId){
    return axios.delete(`${endpointAPIVariables}/sponsors/${sponsorId}`);
  },
  addComment(newComment){
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/comments`, {
        ...newComment,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => reject(err));
    });
  },

  getCommentsByPublicationId(publicationId) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios.get(`${endpointAPIVariables}/publication-comments/${publicationId}`);
        resolve(data.data);
      } catch (err) {
        reject(err);
      }
    })
  },
  addMultiplePublication(newMultiplePublication) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/multiple-publications`, {
        data: newMultiplePublication,
      }).then((res) => {
        resolve(res.data);
      });
    });
  },
  getMultiplePublicaciones() {
    return axios.get(`${endpointAPIVariables}/multiple-publications`);
  },
  deleteMultiplePublication(idMultiplePublication) {
    return axios.delete(`${endpointAPIVariables}/multiple-publications/${idMultiplePublication}`);
  },
  getMultiplePublication(idMultiplePublication) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios.get(`${endpointAPIVariables}/multiple-publications/${idMultiplePublication}`);
        resolve(data.data);
      } catch (err) {
        reject(err);
      }
    })
  },
  getMultiplePublicacionesData(idMultiplePublication) {
    return axios.get(`${endpointAPIVariables}/multiple-publications/${idMultiplePublication}/data`);
  },
  addContact(newContact){
    return new Promise((resolve, reject) => {
      axios.post(`${endpointAPIVariables}/contacts`, {
        data: newContact,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => reject(err));
    });
  },
  updateContact(contact, contactId){
    return new Promise((resolve, reject) => {
      axios.put(`${endpointAPIVariables}/contacts/${contactId}`, {
        data: contact,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => reject(err));
    });
  },
  updatePublication(publication, publicationId){
    return new Promise((resolve, reject) => {
      axios.put(`${endpointAPIVariables}/publications/${publicationId}`, {
        data: publication,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => reject(err));
    });
  },
  updateMultiplePublication(publication, publicationId){
    return new Promise((resolve, reject) => {
      axios.put(`${endpointAPIVariables}/multiple-publications/${publicationId}`, {
        data: publication,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => reject(err));
    });
  },
  getContactById(publicationId) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios.get(`${endpointAPIVariables}/contacts/${publicationId}`);
        resolve(data.data);
      } catch (err) {
        reject(err);
      }
    })
  },
  getContacts() {
    return axios.get(`${endpointAPIVariables}/contacts`);
  },
  deleteContact(idContact) {
    return new Promise((resolve, reject) => {
      axios.delete(`${endpointAPIVariables}/contacts/${idContact}`).then((res) => {
        resolve(res.data);
      });
    });
  }
};
